module.exports = ['indexes._third_chart.m1', 'indexes._third_chart.m4', 'indexes._third_chart.m5', 'indexes._third_chart.m6', 'indexes._third_chart.m7', 'indexes._third_chart.m8', 'indexes.price_segments.piechart.m1'];
